import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import { Box, Grid, Link, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useAlertUiTranslation } from '../../../../../hooks';
import { humanFileSize } from '../Utils/TextTransformationUtil';
const AttachmentBox = ({ id, attachment, actions, onGetAttachment }) => {
    const { t } = useAlertUiTranslation();
    const download = (event, fileId, fileName) => {
        event.preventDefault();
        onGetAttachment(fileId, fileName);
    };
    function infected(virusScan) {
        return !!(virusScan && virusScan.result === 'infected');
    }
    function error(virusScan) {
        return !!(virusScan && virusScan.result === 'error');
    }
    const attachmentSizeAdjusted = attachment.fileSize ? `(${humanFileSize(attachment.fileSize)})` : '';
    return (React.createElement(Box, { key: attachment.fileId, p: 2, mt: 1, sx: { bgColor: '#F5F5F5' } },
        React.createElement(Grid, { container: true, direction: 'row', justifyContent: 'space-between', alignItems: 'center', wrap: 'nowrap' },
            React.createElement(Grid, { item: true, xs: true, zeroMinWidth: true },
                React.createElement(Tooltip, { title: `${attachment.fileName} ${attachmentSizeAdjusted}` },
                    React.createElement(Typography, { noWrap: true },
                        React.createElement(Link, { onClick: (e) => {
                                if (attachment.fileId && attachment.fileName) {
                                    download(e, attachment.fileId, attachment.fileName);
                                }
                            }, sx: {
                                width: '100%',
                                whiteSpace: 'nowrap',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                textAlign: 'left',
                                '&[disabled]': {
                                    color: (theme) => theme.palette.text.secondary,
                                    cursor: 'not-allowed',
                                    textDecoration: 'none',
                                },
                            }, color: 'primary', disabled: infected(attachment.virusScan), variant: 'body1', "aria-label": t('wizard.addMessage.downloadFile'), component: 'button', "data-test": `file-${id}-download-button` },
                            attachment.fileName,
                            " ",
                            attachmentSizeAdjusted)))),
            React.createElement(Grid, { item: true },
                infected(attachment.virusScan) && (React.createElement(Tooltip, { title: t('pages.edit.infectedAttachment') },
                    React.createElement(ErrorIcon, { color: 'error', sx: { verticalAlign: 'middle' }, "aria-label": t('pages.edit.infectedAttachment'), "data-test": `file-${id}-infected-icon` }))),
                error(attachment.virusScan) && (React.createElement(Tooltip, { title: t('pages.edit.errorAttachment') },
                    React.createElement(WarningIcon, { sx: { verticalAlign: 'middle', color: '#FF9800' }, "aria-label": t('pages.edit.errorAttachment'), "data-test": `file-${id}-error-icon` }))),
                actions))));
};
export default AttachmentBox;
